if (!customElements.get('card-swatches')) {
  class CardSwatches extends HTMLElement {
    connectedCallback() {
      this.card = this.closest('.card-wrapper');
      this.storageKey = this.dataset.group ? `card-swatch-${this.dataset.group}` : null;

      this.addEventListener('click', (event) => {
        const link = event.target.closest('.card-swatches__link');
        if (!link || !this.card) return;
        event.preventDefault();
        if (link.getAttribute('aria-current') !== 'true') this.select(link);
        this.remember(link);
      });

      this.restore();
    }

    remember(link) {
      if (!this.storageKey) return;
      try {
        sessionStorage.setItem(this.storageKey, link.dataset.productId);
      } catch (error) {}
    }

    restore() {
      if (!this.storageKey || !this.card) return;
      let savedId = null;
      try {
        savedId = sessionStorage.getItem(this.storageKey);
      } catch (error) {}
      if (!savedId) return;
      const link = this.querySelector(`.card-swatches__link[data-product-id="${savedId}"]`);
      if (link && link.getAttribute('aria-current') !== 'true') this.select(link);
    }

    select(link) {
      const card = this.card;
      const images = card.querySelectorAll('.card__media img');

      if (images[0] && link.dataset.src) {
        images[0].src = link.dataset.src;
        images[0].srcset = link.dataset.srcset;
        images[0].alt = link.dataset.alt || '';
        images[0].removeAttribute('width');
        images[0].removeAttribute('height');
      }
      if (images[1]) {
        if (link.dataset.src2) {
          images[1].src = link.dataset.src2;
          images[1].srcset = link.dataset.srcset2;
          images[1].hidden = false;
        } else {
          images[1].hidden = true;
        }
      }

      card.querySelectorAll('.card__heading a').forEach((anchor) => {
        anchor.href = link.href;
        if (link.dataset.title) anchor.textContent = link.dataset.title;
      });

      const priceTemplate = link.parentElement.querySelector('template.card-swatches__price');
      const currentPrice = card.querySelector('.card-information .price');
      if (priceTemplate && currentPrice) {
        const newPrice = priceTemplate.content.querySelector('.price');
        if (newPrice) currentPrice.replaceWith(newPrice.cloneNode(true));
      }

      this.querySelectorAll('.card-swatches__link').forEach((item) => {
        item.setAttribute('aria-current', item === link ? 'true' : 'false');
      });
    }
  }

  customElements.define('card-swatches', CardSwatches);
}
